import _ from 'lodash'

export const removeEmptyValues = (obj: object): object => {
  const result: any = _.cloneDeep(obj)

  for (const [key, value] of Object.entries(obj)) {
    if (!value) delete result[key]

    if (typeof value === 'object') {
      if (_.isEmpty(value)) delete result[key]
      else result[key] = removeEmptyValues(value)
    }
  }

  return result
}
